"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityTypes = void 0;
var AvailabilityTypes;
(function (AvailabilityTypes) {
    AvailabilityTypes["Available"] = "Available";
    AvailabilityTypes["Unavailable"] = "Unavailable";
})(AvailabilityTypes = exports.AvailabilityTypes || (exports.AvailabilityTypes = {}));
